import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_2 = {
  key: 1,
  class: "text-center py-5"
}
const _hoisted_3 = { class: "flex items-center justify-end w-full mt-5" }
const _hoisted_4 = {
  key: 0,
  class: "flex justify-center py-5"
}
const _hoisted_5 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_6 = { class: "bg-[#34513bd4]! border-2! border-[#34513b]! rounded mb-3 p-2" }
const _hoisted_7 = { class: "text-amber-100 text-[12px] font-bold" }
const _hoisted_8 = {
  key: 0,
  class: "text-amber-100 text-[11px]"
}
const _hoisted_9 = { class: "flex items-center justify-between px-3 py-2 bg-[#34513b]" }
const _hoisted_10 = { class: "text-amber-100 text-[13px] font-bold" }
const _hoisted_11 = { class: "text-[11px] px-2 py-0.5 rounded-full bg-amber-500/20 text-amber-300" }
const _hoisted_12 = { class: "text-center py-3 border-b border-[#34513b]" }
const _hoisted_13 = { class: "text-[#e9c36b] text-2xl font-extrabold" }
const _hoisted_14 = { class: "px-3 py-2 border-b border-[#34513b]" }
const _hoisted_15 = { class: "flex items-center justify-between" }
const _hoisted_16 = { class: "text-white text-[14px] font-bold font-mono tracking-wider" }
const _hoisted_17 = { class: "text-gray-300 text-[11px]" }
const _hoisted_18 = { class: "text-gray-300 text-[11px]" }
const _hoisted_19 = { class: "px-3 py-2 grid grid-cols-2 gap-1 text-[11px]" }
const _hoisted_20 = { class: "text-white ml-1" }
const _hoisted_21 = { class: "text-white ml-1" }
const _hoisted_22 = { class: "col-span-2 text-gray-400" }
const _hoisted_23 = { class: "text-gray-300" }
const _hoisted_24 = { class: "flex gap-2 justify-end px-3 py-2 bg-[#34513b]" }
const _hoisted_25 = { class: "grid grid-cols-4 gap-2 mt-3" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "flex items-center justify-end gap-5 w-full mt-5" }
const _hoisted_28 = {
  key: 1,
  class: "text-center py-5"
}
const _hoisted_29 = {
  key: 0,
  class: "bg-[#34513bd4] border border-[#34513b] rounded-lg overflow-hidden mb-2"
}
const _hoisted_30 = { class: "flex items-center justify-between px-3 py-2 bg-[#34513b]" }
const _hoisted_31 = { class: "text-[11px] px-2 py-0.5 rounded-full bg-amber-500/20 text-amber-300" }
const _hoisted_32 = { class: "text-center py-2 border-b border-gray-200 bg-red-50" }
const _hoisted_33 = {
  key: 0,
  class: "text-red-600 text-xl font-extrabold tabular-nums"
}
const _hoisted_34 = {
  key: 1,
  class: "text-red-600 text-xl font-extrabold"
}
const _hoisted_35 = { class: "text-center py-3 border-b border-[#34513b]" }
const _hoisted_36 = { class: "text-[#e9c36b] text-2xl font-extrabold" }
const _hoisted_37 = { class: "px-3 py-3 border-b border-[#34513b] text-center" }
const _hoisted_38 = { class: "text-white text-2xl font-bold font-mono tracking-wider" }
const _hoisted_39 = ["src"]
const _hoisted_40 = { class: "text-white text-[16px] font-bold" }
const _hoisted_41 = { class: "text-gray-300 text-[16px] mb-3" }
const _hoisted_42 = {
  key: 0,
  class: "px-3 py-3 border-b border-[#34513b]"
}
const _hoisted_43 = { class: "text-white text-[16px] font-bold font-mono tracking-wider mb-2" }
const _hoisted_44 = { class: "px-3 py-2 text-[14px]" }
const _hoisted_45 = { class: "flex items-center justify-center gap-4 flex-wrap" }
const _hoisted_46 = { class: "text-white font-bold ml-1" }
const _hoisted_47 = { class: "text-white font-bold ml-1" }
const _hoisted_48 = { class: "text-center text-gray-400 text-[12px] mt-1" }
const _hoisted_49 = { class: "text-gray-300" }
const _hoisted_50 = {
  key: 2,
  class: "relative w-full"
}
const _hoisted_51 = ["src"]
const _hoisted_52 = { class: "flex flex-col gap-2 w-full mt-4" }
const _hoisted_53 = { class: "flex gap-2 w-full" }
const _hoisted_54 = { class: "text-center py-5" }

export function render(_ctx, _cache) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toast = _resolveComponent("Toast")
  const _component_Step = _resolveComponent("Step")
  const _component_StepList = _resolveComponent("StepList")
  const _component_StepPanel = _resolveComponent("StepPanel")
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_IftaLabel = _resolveComponent("IftaLabel")
  const _component_Message = _resolveComponent("Message")
  const _component_StepPanels = _resolveComponent("StepPanels")
  const _component_Stepper = _resolveComponent("Stepper")

  return (_ctx.isBankUpdate)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "text-white text-xl font-bold" }, "อัปเดตบัญชี", -1 /* HOISTED */)),
        _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-white text-[12px] mt-2" }, "กรุณาอัปเดตบัญชีธนาคาร", -1 /* HOISTED */)),
        _createVNode(_component_Button, {
          label: "อัปเดตบัญชี",
          onClick: _ctx.btnClickUpdateBank,
          class: "mt-4",
          size: "small"
        }, null, 8 /* PROPS */, ["onClick"]),
        _createVNode(_component_Toast)
      ]))
    : (_ctx.isNameEnUpdate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[15] || (_cache[15] = _createElementVNode("h2", { class: "text-white text-xl font-bold" }, "เพิ่มชื่อภาษาอังกฤษ", -1 /* HOISTED */)),
          _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-white text-[12px] mt-2" }, "กรุณาเพิ่มชื่อ-นามสกุล (อังกฤษ) สำหรับ AutoPeer", -1 /* HOISTED */)),
          _createVNode(_component_Button, {
            label: "เพิ่มชื่ออังกฤษ",
            onClick: _ctx.btnClickUpdateNameEn,
            class: "mt-4",
            size: "small"
          }, null, 8 /* PROPS */, ["onClick"]),
          _createVNode(_component_Toast)
        ]))
      : (_openBlock(), _createBlock(_component_Stepper, {
          key: 2,
          value: _ctx.stepper,
          "onUpdate:value": _cache[12] || (_cache[12] = $event => ((_ctx.stepper) = $event)),
          linear: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_StepList, { pt: {root: 'overflow-y-auto [scrollbar-width:thin] [scrollbar-color:rgb(0,143,44)_rgb(0,0,0)]'} }, {
              default: _withCtx(() => [
                _createVNode(_component_Step, {
                  value: "0",
                  pt: { header: 'text-xs!', number: 'text-xs! size-6! min-w-auto!', title:'text-amber-100!' }
                }, {
                  default: _withCtx(() => _cache[17] || (_cache[17] = [
                    _createTextVNode("คำแนะนำ")
                  ])),
                  _: 1 /* STABLE */,
                  __: [17]
                }),
                _createVNode(_component_Step, {
                  value: "1",
                  pt: { header: 'text-xs!', number: 'text-xs! size-6! min-w-auto!', title:'text-amber-100!' }
                }, {
                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                    _createTextVNode("ระบุจำนวนเงิน")
                  ])),
                  _: 1 /* STABLE */,
                  __: [18]
                }),
                _createVNode(_component_Step, {
                  value: "2",
                  pt: { header: 'text-xs!', number: 'text-xs! size-6! min-w-auto!', title:'text-amber-100!' }
                }, {
                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                    _createTextVNode("โอนเงิน / แนบสลิป")
                  ])),
                  _: 1 /* STABLE */,
                  __: [19]
                }),
                _createVNode(_component_Step, {
                  value: "3",
                  pt: { header: 'text-xs!', number: 'text-xs! size-6! min-w-auto!', title:'text-amber-100!' }
                }, {
                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createTextVNode("สำเร็จ")
                  ])),
                  _: 1 /* STABLE */,
                  __: [20]
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_StepPanels, { pt: { root: 'px-0!' } }, {
              default: _withCtx(() => [
                _createCommentVNode(" Step 0: คำแนะนำ "),
                _createVNode(_component_StepPanel, {
                  value: "0",
                  pt: { root: 'bg-transparent!' }
                }, {
                  default: _withCtx(() => [
                    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "bg-[#34513bd4]! border-2! border-[#34513b]! rounded p-3" }, [
                      _createElementVNode("h3", { class: "text-amber-100 text-[14px] font-bold mb-2 border-t pt-3" }, "คำแนะนำการใช้งาน Auto Peer"),
                      _createElementVNode("p", { class: "text-[12px] text-white mt-3" }, [
                        _createTextVNode("Autopeer "),
                        _createElementVNode("span", { class: "text-amber-300" }, "ตรวจสอบเลขบัญชี และยอดเงินทุกครั้งก่อนโอน -> อัปสลิปภายใน 15 นาที"),
                        _createTextVNode(" จากนั้นกด ยืนยัน เงินเข้าทันที "),
                        _createElementVNode("span", { class: "text-amber-300" }, "ฝากขั้นต่ำ 100 บาท สูงสุด 20,000 บาท")
                      ])
                    ], -1 /* HOISTED */)),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_Button, {
                        onClick: _cache[0] || (_cache[0] = $event => (_ctx.stepper = '1')),
                        size: "small",
                        label: "เริ่มต้นใช้งาน",
                        class: "bg-[#008f2c]! border-transparent!"
                      })
                    ])
                  ]),
                  _: 1 /* STABLE */,
                  __: [21]
                }),
                _createCommentVNode(" Step 1: ระบุจำนวนเงิน "),
                (_openBlock(), _createBlock(_component_StepPanel, {
                  key: 'p1-'+_ctx.resetKey,
                  value: "1",
                  pt: { root: 'bg-transparent!' }
                }, {
                  default: _withCtx(() => [
                    (_ctx.isActive)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.pendingLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(_component_ProgressSpinner, { style: {"width":"40px","height":"40px"} })
                              ]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createCommentVNode(" รายการค้าง "),
                                (_ctx.pendingList.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                      _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("p", _hoisted_7, "คุณมีรายการฝากค้างอยู่ " + _toDisplayString(_ctx.pendingList.length) + " รายการ", 1 /* TEXT */),
                                        (_ctx.pendingSummary)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_8, "ยอดรวม: " + _toDisplayString(Number(_ctx.pendingSummary).toLocaleString()) + " บาท", 1 /* TEXT */))
                                          : _createCommentVNode("v-if", true)
                                      ]),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingList, (tx, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: tx.ref,
                                          class: "bg-[#34513bd4] border border-[#34513b] rounded-lg overflow-hidden mb-2"
                                        }, [
                                          _createCommentVNode(" Header "),
                                          _createElementVNode("div", _hoisted_9, [
                                            _createElementVNode("span", _hoisted_10, "รายการ #" + _toDisplayString(index + 1), 1 /* TEXT */),
                                            _createElementVNode("span", _hoisted_11, _toDisplayString(tx.status), 1 /* TEXT */)
                                          ]),
                                          _createCommentVNode(" ยอดเงิน "),
                                          _createElementVNode("div", _hoisted_12, [
                                            _cache[22] || (_cache[22] = _createElementVNode("p", { class: "text-gray-400 text-[11px]" }, "จำนวนเงินที่ต้องโอน", -1 /* HOISTED */)),
                                            _createElementVNode("p", _hoisted_13, _toDisplayString(Number(tx.amount).toLocaleString()), 1 /* TEXT */),
                                            _cache[23] || (_cache[23] = _createElementVNode("p", { class: "text-gray-400 text-[11px]" }, "บาท", -1 /* HOISTED */))
                                          ]),
                                          _createCommentVNode(" บัญชีปลายทาง "),
                                          _createElementVNode("div", _hoisted_14, [
                                            _cache[25] || (_cache[25] = _createElementVNode("p", { class: "text-gray-400 text-[10px] mb-1" }, "โอนเข้าบัญชี", -1 /* HOISTED */)),
                                            _createElementVNode("div", _hoisted_15, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("p", _hoisted_16, _toDisplayString(tx.accountNumber), 1 /* TEXT */),
                                                _createElementVNode("p", _hoisted_17, _toDisplayString(tx.bankName), 1 /* TEXT */),
                                                _createElementVNode("p", _hoisted_18, _toDisplayString(tx.firstName) + " " + _toDisplayString(tx.lastName), 1 /* TEXT */)
                                              ]),
                                              _createVNode(_component_Button, {
                                                onClick: $event => (_ctx.copyToClipboard(tx.accountNumber)),
                                                type: "button",
                                                size: "small",
                                                label: "คัดลอก",
                                                class: "bg-amber-600! border-amber-700! text-white! text-[11px]! py-1!"
                                              }, {
                                                icon: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                                  _createElementVNode("svg", {
                                                    class: "size-3.5",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24"
                                                  }, [
                                                    _createElementVNode("path", {
                                                      stroke: "currentColor",
                                                      "stroke-linejoin": "round",
                                                      "stroke-width": "2",
                                                      d: "M9 8v3a1 1 0 0 1-1 1H5m11 4h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v1m4 3v10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-7.13a1 1 0 0 1 .24-.65L7.7 8.35A1 1 0 0 1 8.46 8H13a1 1 0 0 1 1 1Z"
                                                    })
                                                  ], -1 /* HOISTED */)
                                                ]))]),
                                                _: 2 /* DYNAMIC */
                                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                            ])
                                          ]),
                                          _createCommentVNode(" รายละเอียด "),
                                          _createElementVNode("div", _hoisted_19, [
                                            _createElementVNode("div", null, [
                                              _cache[26] || (_cache[26] = _createElementVNode("span", { class: "text-gray-400" }, "สร้างเมื่อ:", -1 /* HOISTED */)),
                                              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.formatDate(tx.createdDate)), 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("div", null, [
                                              _cache[27] || (_cache[27] = _createElementVNode("span", { class: "text-gray-400" }, "หมดอายุ:", -1 /* HOISTED */)),
                                              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.formatDate(tx.expiredDate)), 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("div", _hoisted_22, [
                                              _cache[28] || (_cache[28] = _createTextVNode(" Ref: ")),
                                              _createElementVNode("span", _hoisted_23, _toDisplayString(tx.ref), 1 /* TEXT */)
                                            ])
                                          ]),
                                          _createCommentVNode(" ปุ่มดำเนินการ "),
                                          _createElementVNode("div", _hoisted_24, [
                                            _createVNode(_component_Button, {
                                              onClick: $event => (_ctx.cancelPendingItem(tx)),
                                              type: "button",
                                              size: "small",
                                              loading: _ctx.form.btn.loading,
                                              label: "ยกเลิก",
                                              severity: "danger",
                                              outlined: "",
                                              class: "text-[11px]! py-1!"
                                            }, null, 8 /* PROPS */, ["onClick", "loading"]),
                                            _createVNode(_component_Button, {
                                              onClick: $event => (_ctx.forceCompletePendingItem(tx)),
                                              type: "button",
                                              size: "small",
                                              loading: _ctx.form.btn.loading,
                                              label: "จบรายการ",
                                              severity: "warn",
                                              class: "text-[11px]! py-1!"
                                            }, null, 8 /* PROPS */, ["onClick", "loading"]),
                                            _createVNode(_component_Button, {
                                              onClick: $event => (_ctx.selectPending(tx)),
                                              type: "button",
                                              size: "small",
                                              label: "ดำเนินการต่อ",
                                              class: "bg-[#008f2c]! border-transparent! text-[11px]! py-1!"
                                            }, null, 8 /* PROPS */, ["onClick"])
                                          ])
                                        ]))
                                      }), 128 /* KEYED_FRAGMENT */)),
                                      _cache[29] || (_cache[29] = _createElementVNode("div", { class: "bg-white! border border-[#34513b]! rounded p-2 mb-3" }, [
                                        _createElementVNode("p", { class: "text-[12px]" }, [
                                          _createElementVNode("span", { class: "text-red-600 font-bold" }, "โอนภายใน 5 นาที ตรวจสอบเลขบช.ทุกครั้งก่อนโอน"),
                                          _createElementVNode("span", { class: "text-black" }, "หากไม่อัปโหลดตามเวลาที่กำหนดคุณต้องดำเนินการแจ้งความว่าโอนเงินผิดและติดต่อธนาคารเพื่อ ดึงเงินคืนด้วยตนเอง กรณียกเลิกรายการ จะถูกระงับการฝากช่องทาง AutoPeer 3 นาที")
                                        ])
                                      ], -1 /* HOISTED */))
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                _createCommentVNode(" ฟอร์มสร้างรายการใหม่ (แสดงเฉพาะไม่มี pending) "),
                                (_ctx.pendingList.length === 0)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _cache[31] || (_cache[31] = _createElementVNode("div", { class: "bg-white! border-2! border-[#34513b]! rounded mb-3 p-1" }, [
                                        _createElementVNode("p", { class: "text-black text-[12px]" }, "ระบุจำนวนเงินที่ต้องการฝาก (จำนวนเต็มร้อยเท่านั้น) ( ฝากขั้นต่ำ 100 บาท สูงสุด 20,000 บาท )")
                                      ], -1 /* HOISTED */)),
                                      _createElementVNode("form", {
                                        onSubmit: _cache[2] || (_cache[2] = _withModifiers((...args) => (_ctx.handleCreateDeposit && _ctx.handleCreateDeposit(...args)), ["prevent"]))
                                      }, [
                                        _createVNode(_component_IftaLabel, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_InputNumber, {
                                              inputId: "amount",
                                              mode: "currency",
                                              currency: "THB",
                                              locale: "th-TH",
                                              minFractionDigits: 0,
                                              maxFractionDigits: 0,
                                              modelValue: _ctx.form.amount,
                                              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.form.amount) = $event)),
                                              class: "w-full",
                                              "input-class": "bg-[#000000d9]! text-amber-100! border border-[#29ab60]!"
                                            }, null, 8 /* PROPS */, ["modelValue"]),
                                            _cache[30] || (_cache[30] = _createElementVNode("label", { for: "amount" }, "ระบุจำนวนเงิน", -1 /* HOISTED */))
                                          ]),
                                          _: 1 /* STABLE */,
                                          __: [30]
                                        }),
                                        _createElementVNode("div", _hoisted_25, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.amountPresets, (amt) => {
                                            return (_openBlock(), _createElementBlock("button", {
                                              key: amt,
                                              type: "button",
                                              onClick: $event => (_ctx.form.amount = amt),
                                              class: _normalizeClass([_ctx.form.amount === amt ? 'bg-amber-600 text-white border-amber-700' : 'bg-[#000000c9] text-white border-[#34513b]', "py-2 rounded-lg text-[13px] font-bold border transition-colors cursor-pointer"])
                                            }, _toDisplayString(amt.toLocaleString()), 11 /* TEXT, CLASS, PROPS */, _hoisted_26))
                                          }), 128 /* KEYED_FRAGMENT */))
                                        ]),
                                        (_ctx.msgErr)
                                          ? (_openBlock(), _createBlock(_component_Message, {
                                              key: 0,
                                              severity: "error",
                                              class: "mt-3"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.msgErr), 1 /* TEXT */)
                                              ]),
                                              _: 1 /* STABLE */
                                            }))
                                          : _createCommentVNode("v-if", true),
                                        _createElementVNode("div", _hoisted_27, [
                                          _createVNode(_component_Button, {
                                            label: "ฝาก",
                                            type: "submit",
                                            loading: _ctx.form.btn.loading,
                                            class: "bg-[#008f2c]! border-transparent! w-full! font-bold"
                                          }, null, 8 /* PROPS */, ["loading"])
                                        ])
                                      ], 32 /* NEED_HYDRATION */)
                                    ], 64 /* STABLE_FRAGMENT */))
                                  : _createCommentVNode("v-if", true)
                              ], 64 /* STABLE_FRAGMENT */))
                        ], 64 /* STABLE_FRAGMENT */))
                      : (_openBlock(), _createElementBlock("div", _hoisted_28, _cache[32] || (_cache[32] = [
                          _createElementVNode("h2", { class: "text-amber-100 text-xl font-bold" }, "ปิดให้บริการชั่วคราว", -1 /* HOISTED */),
                          _createElementVNode("p", { class: "text-[12px] text-amber-100 mt-2" }, "ช่องทางฝากนี้ปิดให้บริการชั่วคราว กรุณาลองช่องทางอื่น ๆ", -1 /* HOISTED */)
                        ])))
                  ]),
                  _: 1 /* STABLE */
                })),
                _createCommentVNode(" Step 2: โอนเงิน + แนบสลิป "),
                (_openBlock(), _createBlock(_component_StepPanel, {
                  key: 'p2-'+_ctx.resetKey,
                  value: "2",
                  pt: { root: 'bg-transparent!' }
                }, {
                  default: _withCtx(() => [
                    _cache[49] || (_cache[49] = _createElementVNode("div", { class: "bg-[#34513bd4]! border-2! border-[#34513b]! rounded mb-3 p-1" }, [
                      _createElementVNode("p", { class: "text-white text-[12px]" }, "โอนเงินจากบัญชีของคุณที่ลงทะเบียน ไปยังเลขบัญชีที่แสดง")
                    ], -1 /* HOISTED */)),
                    (_ctx.activeTx)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createCommentVNode(" Header "),
                          _createElementVNode("div", _hoisted_30, [
                            _cache[33] || (_cache[33] = _createElementVNode("span", { class: "text-amber-100 text-[13px] font-bold" }, "รายการฝาก", -1 /* HOISTED */)),
                            _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.activeTx.status), 1 /* TEXT */)
                          ]),
                          _createCommentVNode(" นับถอยหลังเวลาทำรายการ (real-time) "),
                          _createElementVNode("div", _hoisted_32, [
                            _cache[34] || (_cache[34] = _createElementVNode("p", { class: "text-gray-600 text-[11px]" }, "เวลาที่เหลือในการทำรายการ", -1 /* HOISTED */)),
                            (!_ctx.isExpired)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_ctx.countdownText) + " นาที", 1 /* TEXT */))
                              : (_openBlock(), _createElementBlock("p", _hoisted_34, "หมดเวลาทำรายการ"))
                          ]),
                          _createCommentVNode(" ยอดเงิน "),
                          _createElementVNode("div", _hoisted_35, [
                            _cache[35] || (_cache[35] = _createElementVNode("p", { class: "text-gray-400 text-[11px]" }, "จำนวนเงินที่ต้องโอน", -1 /* HOISTED */)),
                            _createElementVNode("p", _hoisted_36, _toDisplayString(Number(_ctx.activeTx.amount).toLocaleString()), 1 /* TEXT */),
                            _cache[36] || (_cache[36] = _createElementVNode("p", { class: "text-gray-400 text-[11px]" }, "บาท", -1 /* HOISTED */))
                          ]),
                          _createCommentVNode(" บัญชีปลายทาง "),
                          _createElementVNode("div", _hoisted_37, [
                            _cache[38] || (_cache[38] = _createElementVNode("p", { class: "text-gray-400 text-[14px] mb-1" }, "โอนเข้าบัญชี", -1 /* HOISTED */)),
                            _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.activeTx.accountNumber), 1 /* TEXT */),
                            (_ctx.bankIcon && !_ctx.bankIconError)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: _ctx.bankIcon,
                                  alt: "bank",
                                  class: "size-12 rounded-full mx-auto my-2",
                                  onError: _cache[3] || (_cache[3] = $event => (_ctx.bankIconError = true))
                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_39))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.activeTx.bankName), 1 /* TEXT */),
                            _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.activeTx.firstName) + " " + _toDisplayString(_ctx.activeTx.lastName), 1 /* TEXT */),
                            _createVNode(_component_Button, {
                              onClick: _cache[4] || (_cache[4] = $event => (_ctx.copyToClipboard(_ctx.activeTx.accountNumber))),
                              type: "button",
                              label: "คัดลอกเลขบัญชี",
                              class: "bg-amber-600! border-amber-700! text-white! w-full! font-bold"
                            }, {
                              icon: _withCtx(() => _cache[37] || (_cache[37] = [
                                _createElementVNode("svg", {
                                  class: "size-4",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  fill: "none",
                                  viewBox: "0 0 24 24"
                                }, [
                                  _createElementVNode("path", {
                                    stroke: "currentColor",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2",
                                    d: "M9 8v3a1 1 0 0 1-1 1H5m11 4h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v1m4 3v10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-7.13a1 1 0 0 1 .24-.65L7.7 8.35A1 1 0 0 1 8.46 8H13a1 1 0 0 1 1 1Z"
                                  })
                                ], -1 /* HOISTED */)
                              ])),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _createCommentVNode(" PromptPay "),
                          (_ctx.promptPayQR)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                _cache[40] || (_cache[40] = _createElementVNode("p", { class: "text-gray-400 text-[10px] mb-1" }, "PromptPay", -1 /* HOISTED */)),
                                _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.promptPayQR), 1 /* TEXT */),
                                _createVNode(_component_Button, {
                                  onClick: _cache[5] || (_cache[5] = $event => (_ctx.copyToClipboard(_ctx.promptPayQR))),
                                  type: "button",
                                  label: "คัดลอก PromptPay",
                                  class: "bg-amber-600! border-amber-700! text-white! w-full! font-bold"
                                }, {
                                  icon: _withCtx(() => _cache[39] || (_cache[39] = [
                                    _createElementVNode("svg", {
                                      class: "size-4",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      fill: "none",
                                      viewBox: "0 0 24 24"
                                    }, [
                                      _createElementVNode("path", {
                                        stroke: "currentColor",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M9 8v3a1 1 0 0 1-1 1H5m11 4h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v1m4 3v10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-7.13a1 1 0 0 1 .24-.65L7.7 8.35A1 1 0 0 1 8.46 8H13a1 1 0 0 1 1 1Z"
                                      })
                                    ], -1 /* HOISTED */)
                                  ])),
                                  _: 1 /* STABLE */
                                })
                              ]))
                            : _createCommentVNode("v-if", true),
                          _createCommentVNode(" รายละเอียด "),
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("div", null, [
                                _cache[41] || (_cache[41] = _createElementVNode("span", { class: "text-gray-400" }, "สร้างเมื่อ:", -1 /* HOISTED */)),
                                _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.formatDate(_ctx.activeTx.createdDate)), 1 /* TEXT */)
                              ]),
                              _createElementVNode("div", null, [
                                _cache[42] || (_cache[42] = _createElementVNode("span", { class: "text-gray-400" }, "หมดอายุ:", -1 /* HOISTED */)),
                                _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.formatDate(_ctx.activeTx.expiredDate)), 1 /* TEXT */)
                              ])
                            ]),
                            _createElementVNode("p", _hoisted_48, [
                              _cache[43] || (_cache[43] = _createTextVNode("Ref: ")),
                              _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.activeTx.ref), 1 /* TEXT */)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    _cache[50] || (_cache[50] = _createElementVNode("div", { class: "bg-[#34513bd4]! border-2! border-[#34513b]! rounded mb-3 p-1" }, [
                      _createElementVNode("p", { class: "text-amber-100 text-[12px] py-2" }, "แนบสลิปการโอนเงินเพื่อยืนยันรายการฝาก")
                    ], -1 /* HOISTED */)),
                    _createElementVNode("input", {
                      ref: "fileInputRef",
                      type: "file",
                      accept: "image/*",
                      class: "hidden",
                      onChange: _cache[6] || (_cache[6] = (...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)))
                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
                    (!_ctx.form.imgSlip)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          onClick: _cache[7] || (_cache[7] = (...args) => (_ctx.triggerFilePick && _ctx.triggerFilePick(...args))),
                          onDragover: _cache[8] || (_cache[8] = _withModifiers($event => (_ctx.isDragging = !_ctx.isExpired), ["prevent"])),
                          onDragleave: _cache[9] || (_cache[9] = _withModifiers($event => (_ctx.isDragging = false), ["prevent"])),
                          onDrop: _cache[10] || (_cache[10] = _withModifiers((...args) => (_ctx.onDrop && _ctx.onDrop(...args)), ["prevent"])),
                          class: _normalizeClass([[_ctx.isDragging ? 'border-gray-400 bg-[#040202d9]' : 'border-gray-300', _ctx.isExpired ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'], "flex flex-col items-center justify-center gap-3 h-[280px] w-full border-2 border-dashed rounded-2xl bg-[#040202b3] transition-colors"])
                        }, _cache[44] || (_cache[44] = [
                          _createElementVNode("svg", {
                            class: "w-14 h-14 text-gray-300",
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              stroke: "currentColor",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "1.8",
                              d: "M12 16V4m0 0L8 8m4-4 4 4M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"
                            })
                          ], -1 /* HOISTED */),
                          _createElementVNode("span", { class: "text-gray-300 text-sm" }, "อัปโหลดสลิป ลากและวางที่นี่", -1 /* HOISTED */)
                        ]), 34 /* CLASS, NEED_HYDRATION */))
                      : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                          _createElementVNode("img", {
                            src: _ctx.form.imgSlip,
                            alt: "สลิป",
                            class: "w-full max-h-[360px] object-contain rounded-2xl border border-gray-200 bg-white"
                          }, null, 8 /* PROPS */, _hoisted_51),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[11] || (_cache[11] = (...args) => (_ctx.clearSlip && _ctx.clearSlip(...args))),
                            "aria-label": "ลบสลิป",
                            class: "absolute top-2 right-2 flex items-center justify-center w-9 h-9 rounded-lg bg-red-600 hover:bg-red-700 text-white shadow-md"
                          }, _cache[45] || (_cache[45] = [
                            _createElementVNode("svg", {
                              class: "size-5",
                              xmlns: "http://www.w3.org/2000/svg",
                              fill: "none",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                stroke: "currentColor",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"
                              })
                            ], -1 /* HOISTED */)
                          ]))
                        ])),
                    (_ctx.msgErr)
                      ? (_openBlock(), _createBlock(_component_Message, {
                          key: 3,
                          severity: "error",
                          class: "mt-3"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.msgErr), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true),
                    (_ctx.isExpired)
                      ? (_openBlock(), _createBlock(_component_Message, {
                          key: 4,
                          severity: "warn",
                          class: "mt-3"
                        }, {
                          default: _withCtx(() => _cache[46] || (_cache[46] = [
                            _createTextVNode("หมดเวลาทำรายการแล้ว กรุณายกเลิกและเริ่มรายการใหม่")
                          ])),
                          _: 1 /* STABLE */,
                          __: [46]
                        }))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_52, [
                      _createVNode(_component_Button, {
                        onClick: _ctx.handleUploadSlip,
                        type: "button",
                        loading: _ctx.form.btn.loading,
                        disabled: _ctx.isExpired,
                        label: "ยืนยัน",
                        class: "bg-[#00ac73]! border-0! text-white! w-full font-bold"
                      }, {
                        icon: _withCtx(() => _cache[47] || (_cache[47] = [
                          _createElementVNode("svg", {
                            class: "size-4",
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              stroke: "currentColor",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2.5",
                              d: "M5 11.917 9.724 16.5 19 7.5"
                            })
                          ], -1 /* HOISTED */)
                        ])),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["onClick", "loading", "disabled"]),
                      _createElementVNode("div", _hoisted_53, [
                        _createVNode(_component_Button, {
                          onClick: _ctx.handleForceComplete,
                          type: "button",
                          loading: _ctx.form.btn.loading,
                          disabled: _ctx.isExpired,
                          label: "จบรายการ",
                          severity: "warn",
                          class: "flex-1"
                        }, null, 8 /* PROPS */, ["onClick", "loading", "disabled"]),
                        _createVNode(_component_Button, {
                          onClick: _ctx.handleCancelTransfer,
                          type: "button",
                          loading: _ctx.form.btn.loading,
                          label: "ยกเลิกรายการ",
                          severity: "danger",
                          class: "flex-1 font-bold"
                        }, {
                          icon: _withCtx(() => _cache[48] || (_cache[48] = [
                            _createElementVNode("svg", {
                              class: "size-4",
                              xmlns: "http://www.w3.org/2000/svg",
                              fill: "none",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                stroke: "currentColor",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2.5",
                                d: "M6 18 18 6m0 12L6 6"
                              })
                            ], -1 /* HOISTED */)
                          ])),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick", "loading"])
                      ])
                    ]),
                    _cache[51] || (_cache[51] = _createElementVNode("div", { class: "bg-white! border border-[#34513b]! rounded mt-3 p-2" }, [
                      _createElementVNode("p", { class: "text-red-600 text-[12px] font-bold" }, "โอนภายใน 5 นาที ตรวจสอบเลขบช.ทุกครั้งก่อนโอน"),
                      _createElementVNode("p", { class: "text-black text-[12px]" }, "* หากไม่อัปโหลดตามเวลาที่กำหนดคุณต้องดำเนินการแจ้งความว่าโอนเงินผิดและติดต่อธนาคารเพื่อ ดึงเงินคืนด้วยตนเอง"),
                      _createElementVNode("p", { class: "text-black text-[12px]" }, "* กรณียกเลิกรายการ จะถูกระงับการฝากช่องทาง AutoPeer 3 นาที")
                    ], -1 /* HOISTED */))
                  ]),
                  _: 1 /* STABLE */,
                  __: [49,50,51]
                })),
                _createCommentVNode(" Step 3: สำเร็จ "),
                _createVNode(_component_StepPanel, {
                  value: "3",
                  pt: { root: 'bg-transparent!' }
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_54, [
                      _cache[52] || (_cache[52] = _createElementVNode("h2", { class: "text-green-600 text-xl font-bold" }, "เมื่อทำการโอนเงินเรียบร้อยแล้ว", -1 /* HOISTED */)),
                      _cache[53] || (_cache[53] = _createElementVNode("p", { class: "text-amber-100 mt-2" }, "ยอดเงินจะถูกเติมเข้า กระเป๋าเกม ภายใน 5 วินาที", -1 /* HOISTED */)),
                      _createVNode(_component_Button, {
                        label: "กลับหน้าหลัก",
                        onClick: _ctx.resetToStep1,
                        class: "bg-[#008f2c]! border-transparent! mt-4"
                      }, null, 8 /* PROPS */, ["onClick"])
                    ])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_Toast)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["value"]))
}